import { useContext, useState } from 'react';
import UserContext from '../../contexts/userContext.js';

import Card from 'react-bootstrap/Card';
import Stack from 'react-bootstrap/Stack';
import Button from 'react-bootstrap/Button';
import Offcanvas from 'react-bootstrap/Offcanvas';
import InputGroup from 'react-bootstrap/InputGroup';
import Form from 'react-bootstrap/Form';
import Spinner from 'react-bootstrap/Spinner';
import { ConversationCard } from './2-1-1_ConversationCard.jsx';

import { retryFetch, focusOnQueryInput } from "../../utils.js";
import "../../styles/ConversationList.css" 

export const ConversationCards = ({show, setShowConversationHistory}) => {
    const { userContext, setUserContext, setAccount, goHome } = useContext(UserContext);
    const conversationOverviews = userContext.document.conversations || [];
   
    const [isAddingConversation, setIsAddingConversation] = useState(false);
    const handleClose = () => {
        if (userContext.conversation) {
            setShowConversationHistory(false);
        } else {
            goHome();
        }
    };
    
    const hasNoSelectedConversation = userContext.document.conversations.length > 0 && userContext.conversationOverview === undefined;

    return (
        <Offcanvas 
            id="conversationHistory"
            show={show}
            onHide={handleClose}
            backdrop={true}
        >
            {hasNoSelectedConversation ? (
                <Offcanvas.Header>
                    <Offcanvas.Title>Select a Conversation</Offcanvas.Title>
                </Offcanvas.Header>
            ) : (
                <Offcanvas.Header closeButton>
                    <Offcanvas.Title>Conversation History</Offcanvas.Title>
                </Offcanvas.Header>
            )}
            
            <Offcanvas.Body>
                <Stack gap={0} >
                    <a
                        id="newConversationButton"
                        className="no-text-decoration"
                        onClick={() => addConversation(0, {userContext, setUserContext, setAccount, setShowConversationHistory, setIsAddingConversation })}
                    >
                        <Card className='m-2'>
                            <InputGroup >
                                <Form.Control value="New Conversation" className="no-border no-text-decoration" readOnly />

                                <Button
                                    className="a8-dark-blue-background"
                                >
                                    {isAddingConversation ? (
                                        <Spinner animation="border" size="sm" />
                                    ) : (
                                        <i className='bi-plus-circle' />
                                    )}
                                </Button>
                            </InputGroup>
                        </Card>
                    </a>

                    {conversationOverviews.map((conversationOverview, i) => {
                        return <ConversationCard
                            key={`${conversationOverview.conversationid}-${i}`}
                            conversationOverview={conversationOverview}
                            setShowConversationHistory={setShowConversationHistory}
                        />
                    })}
                    
                </Stack>
            </Offcanvas.Body>
        </Offcanvas>
    )
}

export const addConversation = (retryCount, {userContext, setUserContext, setAccount,
                                            setShowConversationHistory, setIsAddingConversation }) => {
    console.log('adding conversation');
    
    if (setIsAddingConversation) {
        setIsAddingConversation(true);
    }

    const documentid = userContext.document.documentid;
    const apiGatewayInvokeUrl = process.env[`REACT_APP_API_GATEWAY_INVOKE_URL__${process.env["REACT_APP_DEPLOYMENT_TYPE"]}`]
    const endpoint = `${apiGatewayInvokeUrl}/doc/${documentid}`;
    const params = {
        method: "POST",
        headers: {
            "Authorization": `Bearer ${userContext.account.idToken}`
        }
    };
    
    fetch(endpoint, params)
        .then(response => response.json())
        .then(responseJson => {
            const conversationOverviews = userContext.document.conversations;
            const newConversationOverview = responseJson.conversationOverview;
            const newConversationOverviews = [newConversationOverview, ...conversationOverviews];

            const tempUserContext = {...userContext};
            tempUserContext.document.conversations = newConversationOverviews;
            tempUserContext.conversationOverview = newConversationOverview;
            tempUserContext.conversation = {
                conversationid: newConversationOverview.conversationid,
                document: userContext.document,
                messages: []
            }
            tempUserContext.showConversationHistory = false;
            console.log('updating userContext with new conversation metadata');
            setUserContext(tempUserContext);

            if (setShowConversationHistory) {
                setShowConversationHistory(false);
            }
            if (setIsAddingConversation) {
                setIsAddingConversation(false);
            }

            focusOnQueryInput(1000);
        })
        .catch(e => {
            console.log('error', e);
            retryFetch(userContext, setAccount, retryCount, addConversation, {userContext, setUserContext, setAccount})
        });
};